import { IContextWrapper } from '@vivli/shared/infrastructure/interface';
import { IPubliclyAvailableFilesContext } from '@vivli/features/studies/infrastructure/interface';
import { PubliclyAvailableFilesContext } from '@vivli/features/studies/infrastructure/context';
import { useMemo, useState } from 'react';
import { IDataPackage, IDataPackageFileDescriptor } from '@vivli/shared/features/data-package/infrastructure/interface';

export const PubliclyAvailableFilesContextWrapper = ({ children }: IContextWrapper) => {
    const [dataPackage, setDataPackage] = useState<IDataPackage>(null);

    const publiclyAvailableFiles = useMemo(() => {
        if (!dataPackage) return;

        return dataPackage?.dataPackageFileDescriptors.filter((x) => x && x?.publicAccessGranted) || [];
    }, [dataPackage?.dataPackageFileDescriptors]);

    const provider: IPubliclyAvailableFilesContext = {
        publiclyAvailableFiles,
        dataPackage,
        setDataPackage
    };

    return <PubliclyAvailableFilesContext.Provider value={provider}>{children}</PubliclyAvailableFilesContext.Provider>;
};
